import React, { useMemo } from "react";
import {
  pocketSliderImages,
  PocketSliderImageObj,
} from "../../../initialValues/screens";
import { useStore } from "../../../store/store";
import { SliderScreenOption } from "../SliderScreen/defaults";

const group4 = ["PXXX", "PXXXX"];
const group5 = ["XXXP", "XXXXP"];

function useScreenPocketSelector(
  screenOptions: SliderScreenOption | undefined,
  isPocketing: boolean
) {
  const addToQuote = useStore((state) => state.addToQuote);

  const chosenConfig = useStore((state) => state.quote.exactConfig);

  const screen = useStore((state) => state.quote.addScreen);
  const screenLayout = useStore((state) => state.quote.screenLayout);
  const screenPocket = useStore((state) => state.quote.screenPocket);

  let displayedPocketImg = "";

  if (!screen) {
    displayedPocketImg = "";
  } else if (screen?.includes("Double")) {
    displayedPocketImg = group4.includes(chosenConfig)
      ? "PXXX Double Pocket Double Screen"
      : group5.includes(chosenConfig)
      ? "XXXP Double Pocket Double Screen"
      : screenPocket &&
        !screenPocket.includes("Left") &&
        !screenPocket.includes("Right")
      ? "Double Screen"
      : screenPocket && screenPocket.includes("Right")
      ? "Double Screen Right Pocket"
      : screenPocket && screenPocket.includes("Left")
      ? "Double Screen Left Pocket"
      : "";
  } else {
    if (screenLayout) {
      displayedPocketImg = screenLayout.includes("Left")
        ? "Screen Left"
        : "Screen Right";
    } else {
      displayedPocketImg = "";
    }
  }

  const material = useStore((state) => state.quote.material);

  const pocketToShow =
    screen &&
    screen.includes("Double") &&
    screenOptions &&
    screenOptions.doublePocket
      ? screenOptions.doublePocket
      : screenOptions?.pocket;

  const getCloudinaryId = (image: PocketSliderImageObj | undefined) => {
    if (!image) return "";

    if (material === "All Wood" && !isPocketing) return image.imgWood;
    if (material === "All Wood" && isPocketing) return image.imgPocketingWood;
    if (material !== "All Wood" && !isPocketing) return image.img;
    if (material !== "All Wood" && isPocketing) return image.imgPocketing;

    return "";
  };

  const handleClick = (label: string, disabled: boolean) => {
    if (disabled) return;

    const checked = label === screenPocket;

    if (checked) {
      let update = { screenPocket: "" };

      if (label.includes("Double")) {
        if (!isPocketing && chosenConfig.includes("-"))
          return addToQuote(update);

        if (!isPocketing) {
          if (chosenConfig.slice(-1) === "X") {
            update["screenPocket"] = "Add Pocket Right";
          } else {
            update["screenPocket"] = "Add Pocket Left";
          }
        }
      }

      addToQuote(update);
    } else {
      addToQuote({ screenPocket: label });
    }
  };

  const filteredPocketImg = useMemo(() => {
    if (!displayedPocketImg) return null;

    const image: PocketSliderImageObj | undefined = pocketSliderImages.find(
      (img) => img.label === displayedPocketImg
    );
    const publicId: string = getCloudinaryId(image);

    return {
      label: image ? image.label : "",
      publicId,
      img2: image ? image.img2 : "",
    };
  }, [displayedPocketImg, material, isPocketing]);

  const pocketLabel =
    screenPocket && screenPocket.replace(" Left", "").replace(" Right", "");

  return {
    pocketLabel,
    filteredPocketImg,
    handleClick,
    pocketToShow,
    chosenConfig,
    displayedPocketImg,
  };
}

export default useScreenPocketSelector;
